@if (isLoading) {
	<div class="overlay-new"></div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'insights.administration.budgets.title' | translate }}</h2>
	<div class="service-header-buttons" style="min-width: 80%">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field style="width: 100%">
				<input [value]="searchText" matInput (keyup)="applyFilter($event)" placeholder="{{ 'insights.administration.budgets.search' | translate }}" #input [cdkTrapFocusAutoCapture]="showSearch" [cdkTrapFocus]="showSearch" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>

		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>

<table class="table-responsive" mat-table recycleRows [dataSource]="dataSource" matSort>
	<ng-container matColumnDef="sheetName">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.budgets.table.colyear' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.sheetName }}</td>
	</ng-container>

	<ng-container matColumnDef="orderType">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.budgets.table.colorder' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.orderType }}</td>
	</ng-container>

	<ng-container matColumnDef="debitorId">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.budgets.table.coldebtor' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.debitorId }}</td>
	</ng-container>

	<ng-container matColumnDef="debitorGroup">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.budgets.table.coldebtorgroup' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.debitorGroup }}</td>
	</ng-container>

	<ng-container matColumnDef="salesPerson">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.budgets.table.colsalesperson' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.salesPerson }}</td>
	</ng-container>

	<ng-container matColumnDef="districtCode">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.budgets.table.colgeography' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.districtCode }}</td>
	</ng-container>

	<ng-container matColumnDef="jan">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Jan</th>
		<td mat-cell *matCellDef="let element">{{ aciesNumForm(element.jan, 0, 0) }}</td>
	</ng-container>

	<ng-container matColumnDef="feb">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Feb</th>
		<td mat-cell *matCellDef="let element">{{ aciesNumForm(element.feb, 0, 0) }}</td>
	</ng-container>

	<ng-container matColumnDef="mar">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Mar</th>
		<td mat-cell *matCellDef="let element">{{ aciesNumForm(element.mar, 0, 0) }}</td>
	</ng-container>

	<ng-container matColumnDef="apr">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Apr</th>
		<td mat-cell *matCellDef="let element">{{ aciesNumForm(element.apr, 0, 0) }}</td>
	</ng-container>

	<ng-container matColumnDef="may">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.budgets.table.colmay' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ aciesNumForm(element.may, 0, 0) }}</td>
	</ng-container>

	<ng-container matColumnDef="jun">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Jun</th>
		<td mat-cell *matCellDef="let element">{{ aciesNumForm(element.jun, 0, 0) }}</td>
	</ng-container>

	<ng-container matColumnDef="jul">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Jul</th>
		<td mat-cell *matCellDef="let element">{{ aciesNumForm(element.jul, 0, 0) }}</td>
	</ng-container>

	<ng-container matColumnDef="aug">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Aug</th>
		<td mat-cell *matCellDef="let element">{{ aciesNumForm(element.aug, 0, 0) }}</td>
	</ng-container>

	<ng-container matColumnDef="sep">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Sep</th>
		<td mat-cell *matCellDef="let element">{{ aciesNumForm(element.sep, 0, 0) }}</td>
	</ng-container>

	<ng-container matColumnDef="oct">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.budgets.table.coloct' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ aciesNumForm(element.oct, 0, 0) }}</td>
	</ng-container>

	<ng-container matColumnDef="nov">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Nov</th>
		<td mat-cell *matCellDef="let element">{{ aciesNumForm(element.nov, 0, 0) }}</td>
	</ng-container>

	<ng-container matColumnDef="dec">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Dec</th>
		<td mat-cell *matCellDef="let element">{{ aciesNumForm(element.dec, 0, 0) }}</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="20" showFirstLastButtons [length]="resultsLength"></mat-paginator>
